import React from 'react';

/**
 * Reusable sortable table header cell component
 * 
 * @param {Object} props
 * @param {string} props.columnKey - The data key this header sorts by
 * @param {Function} props.onSort - Callback when header is clicked
 * @param {string} props.sortClass - CSS class from useTableSort
 * @param {React.ReactNode} props.children - Header text/content
 * @param {Object} props.style - Optional inline styles
 */
const SortableTableHeader = ({ 
  columnKey, 
  onSort, 
  sortClass, 
  children,
  style,
  ...rest 
}) => {
  return (
    <th
      className={sortClass}
      onClick={() => onSort(columnKey)}
      style={style}
      {...rest}
    >
      {children}
      <span className="modal-table-sort-indicator" aria-hidden="true">
        <span className="modal-table-sort-arrow modal-table-sort-arrow--up" />
        <span className="modal-table-sort-arrow modal-table-sort-arrow--down" />
      </span>
    </th>
  );
};

export default SortableTableHeader;